import { LeagueResult, StatusTypes } from "@chesshotel/constants";
import type { LeagueScoreResult } from "@chesshotel/types";
import { observeHomepagePlacement } from "./homepageExperiment";
import { trackEvent } from "./eventTracker";

export function trackPlacementCompletion(
  status: StatusTypes,
  result: LeagueScoreResult | undefined,
  gameId: string,
) {
  if (status === StatusTypes.ABORT || !result) return;
  const gameNr = result.leagueScore?.gameNr;
  const placement =
    result.leagueResult === LeagueResult.PLACEMENT &&
    gameNr >= 1 &&
    gameNr <= 4;
  const entry =
    result.leagueResult === LeagueResult.ENTER_LEAGUE && gameNr === 5;
  if (!placement && !entry) return;
  void observeHomepagePlacement(gameNr, gameId);
  void trackEvent("placement_game_finished", {
    gameId,
    gameNr,
    modeId: result.leagueScore.modeId,
    season: result.leagueScore.season,
  });
}
